/* eslint-disable */
import 'jcarousel';
import 'jquery.cookie';

import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';
import './css/atlas-header-withMenu.scss';
import './css/atlas-page-sections.css';
import './css/hotels-list-atlas.css';


import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import SocialButtons from "@/js/desktop/components/social-btns";
import Search from "@/js/common/Domain/Service/Search";
import HotelFactory from './Domain/Factory/Hotel';
import SearchPageView from "@/js/desktop/View/SearchPage";

var Controller = AbstractSearchController.extend({
	initSocialButtons() {
		new SocialButtons({
			el: '.social-btns'
		});
	},
	initSearchService() {
		this.searchService = new Search({HotelFactory});
	},
	initSearchPageView() {
		this.view = new SearchPageView({
			el: '#forSearchView',
			searchFormViewModel: this.model,
			dataLayerAnalytics: this.dataLayerAnalytics,
		});
	},
	initialize() {
		$.removeCookie('requestFromMainPage', {path: '/', domain: 'all'});
		tourCriteriaService.clearTourCriteriaChangedFields();

		AbstractSearchController.prototype.initialize.call(this);
		this.initSocialButtons();
	}
});

/**
 * Страна - отель /india/hotels
 * Страна - курорт отель /india/resorts/goa/hotels
 */
$(() => {
	new Controller({
		el: 'body'
	});
});


